import React from 'react'

import CheckboxQuestionRenderer from '@progyny/pages/Consultations/components/questions/CheckboxQuestionRenderer'
import RadioQuestionRenderer from '@progyny/pages/Consultations/components/questions/RadioQuestionRenderer'
import RatingTableQuestionRenderer from '@progyny/pages/Consultations/components/questions/RatingTableQuestionRenderer'
import TextAreaQuestionRenderer from '@progyny/pages/Consultations/components/questions/TextAreaQuestionRenderer'
import {QuestionRendererProps} from '@progyny/pages/Consultations/components/questions/types'

const QuestionRenderer: React.FC<QuestionRendererProps> = ({
  question,
  formData,
  handleInputChange,
  isSubmitting,
  colors,
}) => {
  switch (question.type) {
    case 'radio':
      return (
        <RadioQuestionRenderer
          question={question}
          formData={formData}
          handleInputChange={handleInputChange}
          isSubmitting={isSubmitting}
          colors={colors}
        />
      )
    case 'checkbox':
      return (
        <CheckboxQuestionRenderer
          question={question}
          formData={formData}
          handleInputChange={handleInputChange}
          isSubmitting={isSubmitting}
          colors={colors}
        />
      )
    case 'rating_table':
      return (
        <RatingTableQuestionRenderer
          question={question}
          formData={formData}
          handleInputChange={handleInputChange}
          isSubmitting={isSubmitting}
        />
      )
    case 'textarea':
      return (
        <TextAreaQuestionRenderer
          question={question}
          formData={formData}
          handleInputChange={handleInputChange}
          isSubmitting={isSubmitting}
          colors={colors}
        />
      )
    default:
      return null
  }
}

export default QuestionRenderer
